/*requires SearchControl.js*/
//
// DataTimeControl javascript
//
// Ben Ramey
// January 2009
//
HEIJS.registerNamespace("HEIJS.SearchControl");
HEIJS.SearchControl.DateTimeControls = function (parentElement)
{
  parentElement = parentElement || $("div.searchpanel");
  $('input.date-picker', parentElement).datepicker({
    showOn: 'button',
    buttonImage: HEIJS.context.getResourceUri('/resources/images/icons/datetime.png'),
    buttonImageOnly: true,
    changeYear: true,
    changeMonth: true,
    duration: 0,
    gotoCurrent: true
  });

  // gets all the date controls
  // inside of the search criteria
  this.controls = $("div.dateinput", parentElement);
  this.controls.each(
    function (idx, domElement)
    {
      var ctrl = $(domElement);
      var val;

      // at times there is no select box, but instead an
      // input saying what type of date input this is
      // this happens when the designer doesn't want the
      // user to be able to choose between After, Before and Between
      if (ctrl.children("select").length > 0)
      {
        val = ctrl.children("select").val();
      }
      else
      {
        val = ctrl.children("input[id$=DateOperatorValue]").val();
      }

      // the table here is the second date control
      // and the span is the tag around the "AND"
      // that is between the date controls
      if (val !== "BETWEEN")
        ctrl.children("span:last,.datepicker-opword").hide();
      else
        ctrl.children("span:last,.datepicker-opword").show();
    }
  );

  this.setupEvents();
};

HEIJS.SearchControl.DateTimeControls.prototype =
{
  //
  // Properties
  //
  controls: null,

  //
  // Methods
  //
  handleSelectChange: function (e, select)
  {
    if (select.val() === "AFTER"
        || select.val() === "BEFORE")
    {
      select.siblings("span:last").find("input").val("");
      select.siblings("span:last,.datepicker-opword").hide();
    }
    else if (select.val() === "BETWEEN")
    {
      select.siblings("span:last, span").show();
    }
  },

  setupEvents: function ()
  {
    var self = this;
    this.controls.children("select").change(function (e) { self.handleSelectChange(e, $(this)); });
  }
};